<template>
  <div class="bg-loading d-flex justify-content-center align-items-center" v-if="Object.keys($store.state.ui.ajax_queue).length">
    <img src="https://s3.ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/loading.gif">
  </div>
</template>

<script>
module.exports = {
  data: function () {
    return { };
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>
.bg-loading {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
}
.bg-loading img {
  -ms-user-select: none; /* IE 10+ */
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>
